import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'redux-form';
import { Map } from 'immutable';
import UploadField from '../shared/UploadField';
import { checkButtonDisabled } from '../../utils/forms';

const BLANK_VALUES = new Map({
  id: 0,
  dataFilenamePattern: '',
  layoutFilename: '',
  recordLevelTypeId: 0,
});

const propTypes = {
  invalid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  createLayoutFunction: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  reset: PropTypes.func.isRequired,
  pageChangeFunction: PropTypes.func.isRequired,
};

const UploadLayoutForm = ({
  createLayoutFunction,
  invalid,
  pristine,
  handleSubmit,
  submitting,
  reset,
  pageChangeFunction,
}) => (
  <div className="card card-block">
    <h2 className="card-title">Create New Layout</h2>
    <Form onSubmit={handleSubmit(createLayoutFunction.bind(this))}>
      <fieldset>
        <UploadField acceptedFileType=".csv" name="layoutFiles" label="Layout File" />
        <UploadField acceptedFileType=".csv" name="codeFiles" label="Code File (Optional)" />
        <div>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={checkButtonDisabled(invalid || pristine, submitting)}
          >
            {submitting ? <i /> : <i />} Submit
          </button>&nbsp;
          <button type="reset" className="btn btn-cancel" onClick={reset}>
            Clear Form
          </button>&nbsp;
          <button
            type="button"
            className="btn btn-cancel"
            onClick={() => {
              pageChangeFunction(0, BLANK_VALUES);
            }}
          >
            Cancel
          </button>
        </div>
      </fieldset>
    </Form>
  </div>
);

UploadLayoutForm.propTypes = propTypes;

export default UploadLayoutForm;
